export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./filter-search.vue?vue&type=template&id=54179106&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/filter-search/filter-search.vue?vue&type=template&id=54179106&
// module id = 1285
// module chunks = 0